/**
 * Copyright 2016 Taito United Oy
 * All rights reserved.
 */

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import styled from 'styled-components';

// Components
import ChatMessage from './ChatMessage';

const propTypes = {
  messages: PropTypes.array.isRequired,
  company: PropTypes.object.isRequired,
  review: PropTypes.object.isRequired,
  children: PropTypes.element,
  scrollToBottom: PropTypes.func,
};

class ChatMessageList extends PureComponent {
  componentDidMount() {
    const { scrollToBottom } = this.props;
    if (scrollToBottom) scrollToBottom();
  }

  renderMessage = (message, index) => {
    const { review, company } = this.props;
    return (
      <ChatMessage
        key={index}
        message={message.message}
        name={message.is_client ? review.name : company.name}
        sentAt={message.sent_at}
        isClient={message.is_client}
      />
    );
  };

  render() {
    const { messages } = this.props;

    return (
      <Container>
        <Scrollbars style={{ height: 505 }}>
          <Messages>
            {messages.map(this.renderMessage)}
            {this.props.children}
          </Messages>
        </Scrollbars>
      </Container>
    );
  }
}

ChatMessageList.propTypes = propTypes;

const Container = styled.div`
  border: 3px solid ${props => props.theme['grey-normal']};
  border-radius: 6px;
  padding: 3px;
`;

const Messages = styled.div`
  display: flex;
  flex-direction: column;
`;

export default ChatMessageList;
